<template>
    <div class="header-margin text-center p-2">
        <h3>{{ $t('errors.PAGE_NOT_FOUND') }}</h3>
    </div>
</template>

<script>
    export default {};
</script>
